import type { FoodpandaOrder } from './api';

/** 80 mm kitchen ticket (KOT): what to cook, no prices. */
export function KitchenTicket({ order, shopName }: { order: FoodpandaOrder; shopName: string }) {
  const at = new Date(order.acceptedAt ?? order.placedAt ?? order.createdAt);
  const readyBy =
    order.acceptedAt && order.prepMinutes
      ? new Date(new Date(order.acceptedAt).getTime() + order.prepMinutes * 60_000)
      : null;
  const time = (d: Date) => d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  return (
    <div
      style={{
        width: '72mm',
        padding: '4mm',
        fontFamily: 'system-ui, sans-serif',
        fontSize: '11pt',
      }}
    >
      <div style={{ textAlign: 'center', fontWeight: 700 }}>KITCHEN · FOODPANDA</div>
      <div style={{ textAlign: 'center', fontSize: '9pt' }}>{shopName}</div>
      <div style={{ fontSize: '18pt', fontWeight: 800, textAlign: 'center', margin: '2mm 0' }}>
        #{order.code}
      </div>
      <div style={{ fontSize: '9pt' }}>
        {order.expeditionType === 'pickup' ? 'PICK-UP' : 'DELIVERY'} · {time(at)}
        {readyBy ? ` · ready by ${time(readyBy)}` : ''}
      </div>
      {order.customerName && <div style={{ fontSize: '9pt' }}>{order.customerName}</div>}
      <hr style={{ border: 0, borderTop: '1px dashed #000' }} />
      {order.items.map((item, i) => (
        <div key={i} style={{ marginBottom: '1.5mm' }}>
          <div style={{ fontWeight: 700 }}>
            {Number(item.quantity)} × {item.name}
          </div>
          {item.toppings.map((t, j) => (
            <div key={j} style={{ paddingLeft: '5mm' }}>
              + {Number(t.quantity) > 1 ? `${t.quantity} × ` : ''}
              {t.name}
            </div>
          ))}
          {item.comment && (
            <div style={{ paddingLeft: '5mm', fontStyle: 'italic' }}>“{item.comment}”</div>
          )}
        </div>
      ))}
      {order.customerNote && (
        <>
          <hr style={{ border: 0, borderTop: '1px dashed #000' }} />
          <div style={{ fontWeight: 700 }}>NOTE: {order.customerNote}</div>
        </>
      )}
    </div>
  );
}
